module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bottom",
      rawName: "v-bottom",
      value: (0),
      expression: "0"
    }]
  }, [(_vm.$store.state.MenuList2th && _vm.$store.state.MenuList2th.length > 0) ? _c('div', {
    staticClass: "twui-subnav"
  }, [_c('div', {
    staticClass: "twui-subnav-inner"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.changeMenuList3th
    },
    model: {
      value: (_vm.activeId),
      callback: function($$v) {
        _vm.activeId = $$v
      },
      expression: "activeId"
    }
  }, _vm._l((_vm.$store.state.MenuList2th), function(item) {
    return _c('el-tab-pane', {
      key: item.menuId,
      attrs: {
        "label": item.menuName,
        "name": item.menuId
      },
      on: {
        "click": function($event) {
          return _vm.changeMenuList3th(item.menuId, item.appType)
        }
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.$store.state.typeOfAppList.length > 0) ? _c('div', {
    staticClass: "xmenu"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.getAppMenuList
    },
    model: {
      value: (_vm.$store.state.activeAppId),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "activeAppId", $$v)
      },
      expression: "$store.state.activeAppId"
    }
  }, _vm._l((_vm.$store.state.typeOfAppList), function(item) {
    return _c('el-tab-pane', {
      key: item.appId,
      attrs: {
        "label": item.appName,
        "name": item.appId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.MenuList3th && _vm.$store.state.MenuList3th.length > 0) ? _c('div', {
    staticClass: "twui-body-left"
  }, [_c('el-tree', {
    staticClass: "tw-tree",
    attrs: {
      "data": _vm.$store.state.MenuList3th,
      "props": _vm.defaultTreeProps,
      "node-key": "menuId",
      "highlight-current": ""
    },
    on: {
      "node-click": _vm.changeDoc
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "twui-body-right"
  }, [_c('Editor')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2961d110","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-doc.vue
// module id = 591
// module chunks = 1